export default "__VITE_ASSET__11eb2b12__"